module.exports = __webpack_public_path__ + "img/demo-pet-supplies-400x300.c5ce5016.jpg";